import { render, staticRenderFns } from "./images.vue?vue&type=template&id=5d87073c&scoped=true"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"
import style0 from "./images.vue?vue&type=style&index=0&id=5d87073c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87073c",
  null
  
)

export default component.exports